import { ConnectedRouter } from "connected-react-router";
import React from "react";
import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga";
import TagManager from "react-gtm-module";
import { Provider } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";

import App from "./app";
import config, { setCountryCode } from "./constants/config";
import Translation from "./services/translation/translation";
import configureStore, { browsHistory } from "./store/configureStore";

const countryName =
  document.location.hash.toLowerCase().substring(2, 4) === "il" ? "IL" : "GB";
setCountryCode(countryName);

const advancedMatching = { country: countryName };
const options = {
  autoConfig: true, // set pixel's autoConfig
  debug: false, // enable logs
};
ReactPixel.init("2387778004591727", advancedMatching, options);

ReactGA.initialize("UA-119780787-5", { debug: false });

if (
  process.env.REACT_APP_ENV === "production" &&
  !window.location.href.includes("/mobile")
) {
  TagManager.initialize(config.google.tagManager);
}

const store = configureStore();

const Root = () => (
  <Provider store={store}>
    <ConnectedRouter history={browsHistory}>
      <Switch>
        <Route path={"/:country"} component={App} />
        <Route path={"/"} component={App} />
        <Redirect to={"/"} />
      </Switch>
    </ConnectedRouter>
  </Provider>
);

export default Root;
